var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-breadcrumbs',{attrs:{"items":_vm.items,"large":""}}),_c('v-row',_vm._l((_vm.modules),function(item,index){return _c('v-col',{key:index,staticClass:"viewCard",attrs:{"cols":"2"}},[_c('router-link',{attrs:{"to":item.link}},[_c('HoverCard',{attrs:{"cardData":item}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }